/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  TextField,
  Typography,
} from '@mui/material';
import SelectAddSerialForm from './SelectAddSerialForm';

const RobotDirectRegisterCard = ({
  name,
  edit,
  read,
  userId,
  serials,
  error,
  // className,
  onChange,
  onCancel,
  onComplete,
  onBlur,
}) => {
  // const cardClassName = () => {
  //   if (read) return `${className} read`;
  //   if (edit) return `${className} read`;
  //   return className;
  // };
  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      {!edit && (
        <CardActions
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={onCancel}
            sx={{ minWidth: 8 }}
          >
            초기화
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            disabled={!userId || (error && error.userId)}
            onClick={onComplete}
            sx={{ minWidth: 8 }}
          >
            {name === 'register' ? '등록' : '삭제'}
          </Button>
        </CardActions>
      )}
      <Divider />
      <CardContent>
        <Typography variant="subtitle2">manager Id</Typography>
        <TextField
          name="userId-text-input"
          placeholder="managerId를 입력하세요."
          onChange={(e) => onChange(e.target.value, e.target.name)}
          onBlur={onBlur}
          error={!!(error && error.userId)}
          helperText={error && error.userId}
          margin="dense"
          disabled={edit || read}
          fullWidth
          sx={{ mb: 2 }}
        />
        <SelectAddSerialForm
          itemKey={name}
          serials={serials}
          readOnly={read}
          onAdd={onChange}
          onDelete={onChange}
        />
      </CardContent>
    </Card>
  );
};

export default RobotDirectRegisterCard;
